import { api } from '@creditsights/api-ui-web';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const fetchAnalystArticles = async (analystId, page = 1) => {
  const { data } = await api.post('common/v1/feeds/global', { analyst: `analyst/${analystId}` }, { params: { skip: (page - 1) * 25, take: 25 } });
  return data.results;
};
